<!-- <app-breadcrumb
  [dynamicName]="variantName"
  [additionalBreadcrumbs]="[
    { label: 'Product Detail', url: '/admin/manage-products/' + productId }
  ]">
</app-breadcrumb> -->
<app-breadcrumb [productName]="productName" [variantName]="variantName"></app-breadcrumb>
<mat-form-field appearance="fill" class="channel-filter">
  <mat-label>Filter by Channel</mat-label>
  <mat-select [(ngModel)]="selectedChannel" (selectionChange)="onChannelChange()">
    <mat-option value="">All Channels</mat-option>
    <mat-option *ngFor="let channel of channels" [value]="channel.channel_code">
      {{ channel.display_name }}
    </mat-option>
  </mat-select>
</mat-form-field>

<div class="variant-header">
  <h2>{{ variantName }}</h2>
  <p><strong>Variant:</strong> {{ variantId }}</p>
  <p *ngIf="sku"><strong>Sku:</strong> {{ sku }}</p>
  <p *ngIf="productName"><strong>Product:</strong> {{ productName }}</p>
</div>

<mat-tab-group>
  <!-- <mat-tab label="General & Attributes">
    <div class="section" *ngIf="variant">
      <table *ngIf="variant.attributes && getAttributeKeys(variant.attributes).length > 0">
        <tr *ngFor="let key of getAttributeKeys(variant.attributes)">
          <td><strong>{{ key }}:</strong></td>
          <td>
            <input [(ngModel)]="variant.attributes[key]" class="editable-attr" />
          </td>
        </tr>        
      </table>
      <p *ngIf="!variant.attributes || getAttributeKeys(variant.attributes).length === 0">
        No attributes found.
      </p>
    </div>
    <hr />
  </mat-tab> -->
 


  <mat-tab label="General & Attributes">
    <div class="section">
      <ng-container *ngIf="variant as v; else loading">
        <table *ngIf="v.attributes && getAttributeKeys(v.attributes).length > 0">
          <tr *ngFor="let key of getAttributeKeys(v.attributes)">
            <td><strong>{{ key }}:</strong></td>
            <td>{{ v.attributes[key] }}</td>
          </tr>
        </table>
        <p *ngIf="!v.attributes || getAttributeKeys(v.attributes).length === 0">
          No attributes found.
        </p>
        <button mat-raised-button color="accent" class="btn btn-outline-secondary" (click)="editAttributes()">
          ✏️ Edit Attributes
        </button>
        
      </ng-container>
      <ng-template #loading>
        <p>Loading variant...</p>
      </ng-template>
    </div>
    <hr />
  </mat-tab>
  




  <mat-tab label="Images">
    <p>Image Upload Area</p>
  </mat-tab>
  <mat-tab label="Prices">
    <p>Price management by location/attribute</p>
  </mat-tab>
  <mat-tab label="Inventory">
    <div *ngIf="inventory && inventory.length > 0; else noInventory">
      <table class="inventory-table">
        <thead>
          <tr>
            <th>Channel</th>
            <th>On Hand</th>
            <th>Reserved</th>
            <th>Incoming</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of filteredInventory">
            <td>{{ entry.channel_code }}</td>
            <td>{{ entry.on_hand }}</td>
            <td>{{ entry.reserved }}</td>
            <td>{{ entry.incoming }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #noInventory>
      <p>No inventory records found for this variant.</p>
    </ng-template>
  </mat-tab>
  
</mat-tab-group>
